export function genId() {
  return crypto.randomUUID()
}
